















import { Component, Vue, Prop } from 'vue-property-decorator';
import IService from '@/store/modules/services/types/IService';
import ButtonFull from '@/components/ui/buttons/Button.vue';

@Component({
  components: {
    ButtonFull,
  },
})
export default class Service extends Vue {
  @Prop({ type: Object, required: true }) private service!: IService;
  @Prop({ type: Boolean, required: true }) private reversed!: boolean;
}
